.checkboxesContainer {
    display: flex;
    flex-wrap: wrap;
}

.checkboxContainer {
    margin: 0px;
    display: flex;
    align-items: center;
}

.container {
    position: relative;
}

.oneColumn {
    width: 100%;
}

.twoColumns {
    width: 50%;
}

.threeColumns {
    width: 33%;
}